import { EmblaEventType } from 'embla-carousel'
import { Nullable } from '../../types/common'
import { BaseComponent } from '../base-component'
import { CarouselComponent } from './carousel'
import { $el, $elParent } from 'src/scripts/utils/utils'

const CAROUSEL_COMPONENT = 'carousel-component'
const INDICATOR_SELECTOR = '[data-carousel-progress-indicator]'

export class CarouselProgress extends BaseComponent {
  targetEvent: EmblaEventType
  carousel: CarouselComponent

  constructor() {
    super()
    this.targetEvent = this.dataset.target === 'scroll' ? 'scroll' : 'settle'
  }

  mountComponent(): void {
    this.carousel = $elParent(CAROUSEL_COMPONENT, this)

    this.update()
    this.carousel?.embla.on(this.targetEvent, this.handleProgress)
    this.carousel?.embla.on('reInit', this.handleCarouselReInit)
  }

  unmountComponent(): void {
    this.carousel?.embla.off(this.targetEvent, this.handleProgress)
    this.carousel?.embla.off('reInit', this.handleCarouselReInit)
  }

  handleProgress = (): void => {
    this.update()
  }

  handleCarouselReInit = (): void => {
    this.update()
  }

  update(): void {
    const indicator = $el(INDICATOR_SELECTOR, this)

    if (!indicator) {
      return
    }

    indicator.style.transform =
      this.dataset.axis === 'vertical'
        ? `translate3d(0, ${this.getProgress()}%, 0)`
        : `translate3d(${this.getProgress()}%, 0, 0)`
  }

  getProgress(): number {
    return this.dataset.target === 'scroll'
      ? this.getProgressByScroll()
      : this.getProgressBySlideInView()
  }

  getProgressBySlideInView(): number {
    if (!this.carousel) {
      return 0
    }

    const slideCount = this.carousel.embla.slideNodes().length
    const visibleSlides = this.carousel.embla.slidesInView()
    const lastVisibleSlide = visibleSlides[visibleSlides.length - 1] + 1
    const progressPerSlide = 100 / slideCount

    return Math.ceil(progressPerSlide * lastVisibleSlide)
  }

  getProgressByScroll(): number {
    if (!this.carousel) {
      return 0
    }

    return Math.max(0, Math.min(1, this.carousel.embla.scrollProgress())) * 100
  }
}
